<template>
  <a-card class="courseVideo">
    <div :class="advanced ? 'search' : null" @keyup.enter="getList('search')" style="margin-bottom: 15px">
      <a-form-model layout="inline" :model="search">
        <a-form-model-item label="视频名称">
          <a-input allowClear placeholder="请输入视频名称" :maxLength="20" v-model.trim="search.Name" />
        </a-form-model-item>
        <a-form-model-item label="视频类型">
          <a-select allowClear v-model="search.scientificName" placeholder="请选择视频状态" style="width: 172px">
            <a-select-option :value="'大脑故事'">大脑故事</a-select-option>
            <a-select-option :value="'大脑健身房'">大脑健身房</a-select-option>
            <a-select-option :value="'大脑与生活'">大脑与生活</a-select-option>
            <a-select-option :value="'大脑导航'">大脑导航</a-select-option>
            <a-select-option :value="'游戏指导'">游戏指导</a-select-option>
            <a-select-option :value="'大脑加油站'">大脑加油站</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="一级能力">
          <a-tree-select v-model="search.FirstAbilityId" treeDefaultExpandAll style="width: 172px" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="选择所属模块" allow-clear>
            <a-tree-select-node :key="items.id" :title="items.name" :value="items.id" v-for="items in treeData" :selectable="false">
              <template v-if="items.children">
                <a-tree-select-node :key="item.id" :title="item.name" :value="item.id" v-for="item in items.children">
                  <template v-if="item.children">
                    <a-tree-select-node :key="el.id" :title="el.name" :value="el.id" v-for="el in item.children" />
                  </template>
                </a-tree-select-node>
              </template>
            </a-tree-select-node>
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select allowClear v-model="search.Enabled" placeholder="请选择视频状态" style="width: 172px">
            <a-select-option value="true">启用</a-select-option>
            <a-select-option value="false">禁用</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item style="margin-right: 35px">
          <a-button @click="getList('search')" type="primary"> 查询 </a-button>
          <a-button @click="resetSearch()" style="margin-left: 10px"> 重置 </a-button>
        </a-form-model-item>
        <a-form-model-item v-permission="`/content/CourseVideo/CourseVideoSeting`">
          <a-button @click="addEgame()" icon="plus" type="primary">添加视频</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div>
      <a-table
        :loading="loading"
        :columns="columns"
        :rowKey="(text, record) => text.id"
        :data-source="dataSource"
        class="components-table-demo-nested"
        :pagination="{
          current: search.PageIndex,
          pageSize: search.PageSize,
          total: total,
          showSizeChanger: true,
          showLessItems: true,
          showQuickJumper: true,
          showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
          onChange: onPageChange,
          onShowSizeChange: onSizeChange,
        }"
      >
        <div slot="icon" slot-scope="text, record">
          <img :src="record.icon | filterUrl" alt="" style="width: 30px; height: 30px" />
        </div>
        <div slot="age" slot-scope="text, record">
          {{ text.minAge + ' - ' + text.maxAge }}
        </div>
        <div slot="firstAbilityName" slot-scope="text, record">
          <div class="self_td" v-for="item in record.abilitys" :key="item.id">
            <span v-if="item.firstAbilityName == item.firstAbilityId"></span>
            <span v-else>{{ item.firstAbilityName }}</span>
          </div>
        </div>
        <div slot="estimatedTime" slot-scope="text, record" v-auth="`Content.CourseVideo.Enabled`">
          {{ text.estimatedTime }}
        </div>
        <div slot="status" slot-scope="text, record" v-auth="`Content.CourseVideo.Enabled`">
          <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.enabled" @click="StatusChange(record)" />
        </div>
        <div slot="action" slot-scope="text, record" class="action">
          <a @click="edit(record)" v-permission="`/content/CourseVideo/CourseVideoSeting`"> <a-icon type="edit" />编辑 </a>
          <a @click="videoView(record)">预览</a>
          <a-popconfirm title="确定删除？" @confirm="deleteEgame(record)" v-permission="`Content.CourseVideo.Delete`">
            <a class="red"> <a-icon type="delete" />删除 </a>
          </a-popconfirm>
        </div>
      </a-table>
    </div>
    <!-- 查看资源 -->
    <a-modal v-model="isView" @cancel="previewModalCancel" title="查看资源" width="50%" destroyOnClose class="ing" :footer="null">
      <div class="prism-player" id="J_prismPlayer"></div>
    </a-modal>
  </a-card>
</template>

<script>
const columns = [
  { title: '视频名称', dataIndex: 'contentName', key: 'contentName' },
  { title: '版本名称', dataIndex: 'versionName', key: 'versionName' },
  { title: 'icon', scopedSlots: { customRender: 'icon' }, key: 'icon' },
  { title: '视频类型', dataIndex: 'scientificName', key: 'scientificName' },
  { title: '适用年龄', scopedSlots: { customRender: 'age' }, key: 'age' },
  { title: '一级能力', scopedSlots: { customRender: 'firstAbilityName' }, key: 'firstAbilityName', class: 'testClass' },
  { title: '视频时长', scopedSlots: { customRender: 'estimatedTime' }, key: 'estimatedTime' },
  { title: '备注', dataIndex: 'remark', key: 'remark' },
  { title: '状态', scopedSlots: { customRender: 'status' }, key: 'status' },
  { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }, align: 'center' },
]
export default {
  name: 'courseVideo',
  data() {
    return {
      advanced: false,
      istoggleAdvanced: false, //是否显示展开按钮
      dataSource: [],
      columns,
      total: 0,
      treeData: [],
      selectId: '',
      loading: true,
      search: {
        PageIndex: 1,
        PageSize: 10,
        ContentType: 4,
        Name: '',
        FirstAbilityId: undefined,
        Enabled: undefined,
        scientificName: undefined,
      },
      statusType: '',
      isView: false,
      AliPlayer: null, // 阿里视频播放插件
    }
  },
  created() {
    this.initSearch()
    this.getList()
    this.getSelect()
  },
  methods: {
    initSearch() {
      this.search.Name = this.$route.query.Name
      this.search.scientificName = this.$route.query.scientificName
      this.search.Enabled = this.$route.query.Enabled
      this.search.PageSize = Number(this.$route.query.PageSize) || 10
      this.search.PageIndex = Number(this.$route.query.PageIndex) || 1
      this.search.FirstAbilityId = Number(this.$route.query.FirstAbilityId) || undefined
    },
    setQuery() {
      const query = {}
      for (const key in this.search) {
        if (this.search[key] && typeof this.search[key] !== 'object') {
          query[key] = this.search[key]
        }
      }
      this.$router.push({ query })
    },

    videoView(record) {
      this.loading = true
      this.$message.destroy()
      let params = {
        contentId: record.id,
      }
      this.$http.Course.GetPlayAuth(params)
        .then((res) => {
            this.isView = true
            this.$nextTick(() => {
              this.AliPlayer = new Aliplayer(
                {
                  id: 'J_prismPlayer',
                  width: '100%',
                  height: '500px',
                  autoplay: true,
                  vid: res.data.body.videoMeta.videoId, //播放方式二必选参数。可以通过点播控制台（媒资库>音/视频路径）查询。示例：1e067a2831b641db90d570b6480f****。
                  playauth: res.data.body.playAuth, //播放方式二必选参数。参数值可通过调用GetVideoPlayAuth接口获取。
                },
                function (player) {
                  console.log('The player is created.')
                }
              )
            })
         
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 预览弹框关闭回调
    previewModalCancel() {
      if (this.AliPlayer) {
        this.AliPlayer.pause()
        this.AliPlayer.dispose()
        this.AliPlayer = null
      }
    },
    StatusChange(record) {
      this.$message.destroy()
      const fn = () => {
        let formData = new FormData()
        formData.append('id', record.id)
        this.loading = true
        this.$http.updatestatus(formData).then((res) => {
          this.loading = false
            record.enabled = !record.enabled
            this.$message.success('修改成功')
         
        })
      }
      if (record.enabled) {
        this.$confirm({
          title: `确认禁用【${record.contentName}】`,
          content: '视频禁用后，已配置的课程将移除该视频且不可恢复，请谨慎操作',
          centered: true,
          onOk: fn,
        })
        return
      }
      let formData = new FormData()
      formData.append('id', record.id)
      formData.append('enabled', false)
      this.loading = true
      this.$http.contentCheckStatus(formData).then((res) => {
          fn()
        
      })
    },
    addEgame() {
      this.$router.push({
        path: '/content/CourseVideo/CourseVideoSeting',
        query: {
          type: 'add',
        },
      })
    },
    edit(record) {
      this.$store.commit('content/setCourseVideoInfo', { fullPath: this.$route.fullPath, ...record })
      sessionStorage.setItem('EgameItem', JSON.stringify(record))
      this.$router.push({
        path: '/content/CourseVideo/CourseVideoSeting',
        query: {
          type: 'edit',
          id: record.id,
          contentName: record.contentName,
          versionName: record.versionName,
        },
      })
    },
    getSelect() {
      let params = {
        isSelect: true,
        abilityType: 0,
      }
      this.$http.loadallsel(params).then((res) => {
          this.treeData = res.data.data
      })
    },
    getList(search) {
      if (search) {
        this.search.PageIndex = 1
      }
      this.setQuery()
      this.$http
        .EGamegelist(this.search)
        .then((res) => {
            res.data.data.items.forEach((v) => {
              if (v.estimatedTime < 60) {
                if (v.estimatedTime < 10) {
                  v.estimatedTime = '00:00:' + Math.floor(v.estimatedTime) + '0'
                } else {
                  v.estimatedTime = '00:00:' + Math.floor(v.estimatedTime)
                }
              } else if (v.estimatedTime > 59 && v.estimatedTime < 3600) {
                let m = Math.floor(v.estimatedTime / 60) < 10 ? '0' + Math.floor(v.estimatedTime / 60) + ':' : Math.floor(v.estimatedTime / 60) + ':'
                let s = v.estimatedTime % 60 < 10 ? '0' + Math.floor(v.estimatedTime % 60) : Math.floor(v.estimatedTime % 60)
                v.estimatedTime = '00:' + m + s
              } else {
                let h = Math.floor(v.estimatedTime / 3600) < 10 ? '0' + Math.floor(v.estimatedTime / 3600) + ':' : Math.floor(v.estimatedTime / 3600) + ':'
                let min = v.estimatedTime % 3600
                let m = Math.floor(min / 60) < 10 ? '0' + Math.floor(min / 60) + ':' : Math.floor(min / 60) + ':'
                let s = min % 60 < 10 ? '0' + Math.floor(min % 60) : Math.floor(min % 60)
                v.estimatedTime = h + m + s
              }
            })
            this.dataSource = res.data.data.items
            this.total = res.data.data.totalCount
            this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
    deleteEgame(record) {
      this.$confirm({
        title: `确认删除【${record.contentName}】`,
        content: '视频删除后所有相关数据都将删除且不可恢复，请谨慎操作',
        centered: true,
        onOk: () => {
          let formData = new FormData()
          formData.append('contentId', record.id)
          this.loading = true
          this.$http.deleteEGamege(formData).then((res) => {
            this.loading = false
              this.getList()
              this.$message.success('删除成功')
           
          })
        },
      })
    },
    onPageChange(page, size) {
      this.search.PageIndex = page
      this.getList()
    },
    onSizeChange(page, size) {
      this.search.PageIndex = 1
      this.search.PageSize = size
      this.getList()
    },
    resetSearch() {
      this.search = {
        PageIndex: 1,
        PageSize: 10,
        ContentType: 4,
        Name: '',
        FirstAbilityId: undefined,
        Enabled: undefined,
      }
      this.getList()
    },
  },
}
</script>

<style scoped>
.courseVideo >>> .standard-table .alert {
  display: none !important;
}

.courseVideo >>> .searchForm {
  display: flex;
}
.courseVideo >>> .searchForm .fold {
  width: 91%;
  display: flex;
}
.sbtn {
  display: flex;
  align-items: center;
  height: 40px;
}
</style>
<style lang="less" scoped>
/deep/ .ant-table-tbody .testClass {
  padding: 0 !important;
}
.self_td {
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  // justify-content: center;
}
</style>
